import { useContext, useEffect, useState } from "react"
import { DateTime } from "luxon"
import { lessonsContext } from "../providers/lessons.provider"
import { profileContext } from "../providers/profile.provider"
import { getLessonsInRange } from "../utils/firestore.utils"
import { heldLessons } from "../utils/cancellation.utils"
import { getWeekBounds, sortByStart } from "../utils/week.utils"

const NONE = []

// Le lezioni che il maestro ha negli altri circoli in un giorno qualsiasi.
// Di solito il giorno sta nella settimana che il provider ascolta già, e la
// risposta è lì; per un giorno di un'altra settimana — una lezione nuova
// spostata più in là, per dire — si ascolta quel giorno e basta, finché
// serve. Vuoto se si è scelto di non vedere gli altri circoli.
function useElsewhereOnDate(date) {
	const { coach } = useContext(profileContext)
	const { shownOtherSchoolIDs, elsewhereWeekStart, elsewhereLessons } =
		useContext(lessonsContext)
	const isLoaded = Boolean(date) && getWeekBounds(date).start === elsewhereWeekStart
	const schoolsKey = (shownOtherSchoolIDs ?? []).join(",")
	const mustListen = Boolean(date && coach && schoolsKey && !isLoaded)

	const [ownLessons, setOwnLessons] = useState({ key: null, lessons: NONE })
	const key = mustListen ? `${coach.coachID}|${date}|${schoolsKey}` : null

	useEffect(() => {
		if (!key) return
		const bySchool = {}
		const day = DateTime.fromISO(date).toJSDate()
		const unsubscribers = schoolsKey.split(",").map(schoolID =>
			getLessonsInRange(coach.coachID, schoolID, day, day, byDate => {
				bySchool[schoolID] = byDate[date] ?? []
				setOwnLessons({ key, lessons: sortByStart(heldLessons(Object.values(bySchool).flat())) })
			}),
		)
		return () => unsubscribers.forEach(unsubscribe => unsubscribe())
		// la chiave dice già tutto quello da cui dipende l'ascolto
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key])

	if (!schoolsKey) return NONE
	if (isLoaded) return elsewhereLessons?.[date] ?? NONE
	return ownLessons.key === key ? ownLessons.lessons : NONE
}

export default useElsewhereOnDate
